import { FC } from "react";
import { Link } from "react-router-dom";
import { Vacancy } from "../models/Vacancies";
import { DATE_OPTIONS, formatDate } from "../../../utilities/dateUtilities";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
export const JobCard: FC<{ job: Vacancy }> = (props) => {
  return (
    <div className="p-4 border bg-gray-25">
      <div className=" bg-gray-25 rounded-t-md">
        <div className="flex justify-between">
          <p className="text-xs text-gray-800">
            {`Date Posted: ${formatDate(
              new Date(props.job.datePosted),
              DATE_OPTIONS.dMY
            )}`}
          </p>

          <Link
            to={props.job.id}
            className="flex items-center gap-2 pl-4 text-sm font-medium text-primary-900"
          >
            View Opening
            <span>
              <ArrowRightIcon
                className={`w-3 h-3 text-primary-900`}
                aria-hidden="true"
              />
            </span>
          </Link>
        </div>

        <div className="py-6">
          <span
            className={` inline-flex items-center rounded-full text-sm font-medium`}
          >
            <div className="text-primary-910">{props.job.department}</div>
          </span>
          <p className="mt-1 text-lg font-semibold">{props.job.title}</p>
        </div>

        <p className="flex items-center gap-1 text-sm text-gray-700">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
              />
            </svg>
          </span>
          {props.job.location}
        </p>
      </div>
    </div>
  );
};
